export function setLocalStorage(storage, key, value, access) {
  if (access) {
    try { storage.setItem(key, value); } catch (e) {}
  }
  return value;
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/setLocalStorage.js
// module id = 859
// module chunks = 2